import React, { useEffect, useState } from 'react';
import { Card } from '../ui/card';
import {
  Refrigerator,
  BrushCleaning,
  PawPrint,
  Utensils,
  Grid2x2,
  Archive,
  WashingMachine
} from 'lucide-react';

const OvenIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="3" y="2" width="18" height="20" rx="2" />
    <path d="M3 8h18" />
    <path d="M8 5h.01" />
    <path d="M12 5h.01" />
    <path d="M16 5h.01" />
    <rect x="7" y="11" width="10" height="7" rx="1" />
  </svg>
);

const ICON_BACKGROUNDS = [
  'linear-gradient(135deg, #cfa64b, #b68426)',
  'linear-gradient(135deg, #0f8c82, #0a6c63)'
];

const getColumnCount = (width) => {
  if (width >= 1024) return 4;
  if (width >= 640) return 2;
  return 1;
};

const BASE_SERVICES = [
    {
      id: 'oven',
      name: 'Oven Cleaning',
      price: 35,
      description: 'Scrub inside & outside for maximum cleanliness',
      icon: OvenIcon
    },
    {
      id: 'fridge',
      name: 'Fridge Cleaning',
      price: 35,
      description: 'Refresh interior shelves, drawers & seals',
      icon: Refrigerator
    },
    {
      id: 'baseboards',
      name: 'Baseboard Detailing',
      price: 25,
      description: 'Hand-wipe baseboards throughout the home',
      icon: BrushCleaning
    },
    {
      id: 'petHair',
      name: 'Pet Hair Removal',
      price: 30,
      description: 'Remove pet hair from floors and furniture',
      icon: PawPrint
    },
    {
      id: 'dishwashing',
      name: 'Dishwashing by Hand',
      price: 25,
      description: 'Wash all dishes, pots and silverware',
      icon: Utensils
    },
    {
      id: 'windows',
      name: 'Interior Windows',
      price: 40,
      description: 'Polish interior glass panes & window sills',
      icon: Grid2x2
    },
    {
      id: 'cabinets',
      name: 'Cabinet & Drawer',
      price: 30,
      description: 'Wipe inside all kitchen cabinets and drawers',
      icon: Archive
    },
    {
      id: 'laundry',
      name: 'Laundry Service',
      price: 25,
      description: 'Wash, dry & fold with your home machines',
      icon: WashingMachine
    }
];

export default function ExtraServices({ selectedExtras, onExtrasChange }) {
  const [columns, setColumns] = useState(() => {
    if (typeof window === 'undefined') return 1;
    return getColumnCount(window.innerWidth);
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const handleResize = () => {
      setColumns(getColumnCount(window.innerWidth));
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const extraServices = BASE_SERVICES.map((service, index) => {
    const safeColumns = columns || 1;
    const row = Math.floor(index / safeColumns);
    const col = index % safeColumns;
    const background = ICON_BACKGROUNDS[(row + col) % ICON_BACKGROUNDS.length];

    return {
      ...service,
      background
    };
  });

  const toggleExtra = (extraId) => {
    if (selectedExtras.includes(extraId)) {
      onExtrasChange(selectedExtras.filter(id => id !== extraId));
    } else {
      onExtrasChange([...selectedExtras, extraId]);
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="section-heading extras-heading" style={{ textAlign: 'center' }}>Extra Services</h2>
      </div>

      <div className="extras-grid">
        {extraServices.map((service) => {
          const Icon = service.icon;
          const isSelected = selectedExtras.includes(service.id);
          
          return (
            <Card
              key={service.id}
              className={`p-6 lg:p-7 cursor-pointer extra-card ${isSelected ? 'selected' : ''}`}
              onClick={() => toggleExtra(service.id)}
            >
              <div className="text-center">
                <div className="extra-icon-badge mx-auto mb-4" style={{ background: service.background }}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h4 className="extra-title mb-1">
                  {service.name}
                </h4>
                <p className="extra-desc mb-2">
                  {service.description}
                </p>
                <p className="extra-price">
                  +${service.price}
                </p>
                {isSelected && (
                  <div className="mt-2">
                    <span className="svc-chip">Added</span>
                  </div>
                )}
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
